import api from 'poly-eshop4/eshop/ui/js/container';

$(document).on('submit', '[data-reels-reveal] [data-add-shoppinglist-position]', function(event) {
  event.preventDefault();
  let qty = $(this).find('[data-add-shoppinglist-position-quantity]').first();
  if (qty.length === 0) {
    qty = $(this).find('input[name="quantity"]').first();
  }
  api.addPosition(qty, 'shoppinglist').then(() => {
    $(this).closest('[data-reveal]').foundation('close');
  });
});
